// Who may see individual-level fatigue data (FM-10).
//
// The dashboard is cohort-level by default and deliberately so — see NOT_MEDICAL
// in ./methodology. Individual breakdowns are an escalation path for the people
// who own duty of care, not a browsing feature, so they are gated on two things:
//
//   1. central admin — the only role with a cross-client remit; and
//   2. the selected client not having anonymisation switched on. If a client has
//      asked for anonymised reporting, naming individuals contradicts that even
//      for a central admin, which is why this checks selectedClientAnonymised
//      rather than isAnonymised.
//
// When the real fatigue API lands this must be enforced server-side too; the
// hook only decides what the UI offers.

import { useClientScope } from '../../../../../shared/contexts/ClientScopeContext';

export interface IndividualAccess {
  /** True when individual-level drill-down may be offered at all. */
  allowed: boolean;
  /** Plain-English reason shown in the locked state when allowed is false. */
  reason: string;
}

export const useIndividualAccess = (): IndividualAccess => {
  const { isCentralAdmin, selectedClientAnonymised } = useClientScope();

  if (!isCentralAdmin) {
    return {
      allowed: false,
      reason:
        'Individual-level fatigue detail is limited to central administrators. Cohort figures above cover the same period.',
    };
  }

  if (selectedClientAnonymised) {
    return {
      allowed: false,
      reason:
        'This client reports anonymised data, so individual-level fatigue detail is not available. Cohort figures above cover the same period.',
    };
  }

  return { allowed: true, reason: '' };
};
